











import { Component, Vue, Prop } from 'vue-property-decorator'
import Paperclip from '@/assets/img/paperclip.svg?inline'

@Component({
  components: {
    Paperclip
  }
})
export default class AttachButton extends Vue {
  @Prop({ default: false }) active!: Boolean;
  @Prop({ default: false }) disabled!: Boolean;
}

